import { render, staticRenderFns } from "./Ticker.vue?vue&type=template&id=f0010196&scoped=true&lang=pug"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"
import style0 from "./Ticker.vue?vue&type=style&index=0&id=f0010196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0010196",
  null
  
)

export default component.exports